import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Chapter } from "./motion";

const LINES = [
  { text: "Sharp cuts", style: "solid" },
  { text: "Clean fades", style: "stroke" },
  { text: "Good vibes", style: "rust" },
  { text: "Free drinks", style: "red" },
  { text: "Walk ins welcome", style: "solid" },
  { text: "No BS", style: "red" },
];

const WhyLine = ({ line, index }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const x = useTransform(
    scrollYProgress,
    [0, 1],
    [index % 2 === 0 ? -70 : 70, 0]
  );

  const color =
    line.style === "rust"
      ? "text-rust"
      : line.style === "red"
        ? "text-polered"
        : line.style === "stroke"
          ? "text-stroke-paper"
          : "text-paper";

  return (
    <motion.div
      ref={ref}
      style={{ x }}
      data-testid={`why-line-${index}`}
      className={`whitespace-nowrap font-display text-[13vw] uppercase leading-[0.9] sm:text-[10vw] lg:text-[8.5rem] ${color}`}
    >
      {line.text}
    </motion.div>
  );
};

const Why = () => (
  <section
    data-testid="why-section"
    className="overflow-hidden border-b-2 border-ink bg-ink py-20 lg:py-28"
  >
    <div className="mx-auto max-w-[1500px] px-4 sm:px-6">
      <Chapter num="04" label="Why Oliver's" dark />
      <div className="mt-10 flex flex-col gap-2">
        {LINES.map((l, i) => (
          <WhyLine key={l.text} line={l} index={i} />
        ))}
      </div>
    </div>
  </section>
);

export default Why;
